import { isAxiosError } from 'axios';

import { useNotificationStore } from '@/common';

export const displayError = (error: any) => {
  if (isAxiosError(error)) {
    const errorTitle = error?.response?.data?.title;
    const errorMessage = error?.response?.data?.detail;

    useNotificationStore.getState().addNotification({
      title: errorTitle,
      type: 'error',
      message: errorMessage,
    });
  }
};
